import { LoadLevel } from 'protocol/model/dto_system_load_pb';

import { SourceKey, SourceSettings, SystemLoadSettings } from './types';

export const sourceKeys: SourceKey[] = [
  'UploadKafka',
  'UploadCBCT',
  'PipelineOrgPending',
  'PipelineOrgsCount',
];

export const levelTagColor: Record<LoadLevel, string> = {
  [LoadLevel.LoadLevel_InvalidValue]: 'default',
  [LoadLevel.LoadLevel_Low]: 'green',
  [LoadLevel.LoadLevel_Medium]: 'orange',
  [LoadLevel.LoadLevel_High]: 'red',
};

export const emptySourceSettings: SourceSettings = {
  enabled: true,
  manual: LoadLevel.LoadLevel_InvalidValue,
  medium: 0,
  high: 0,
};

export const emptySettings: SystemLoadSettings = {
  UploadKafka: emptySourceSettings,
  UploadCBCT: emptySourceSettings,
  PipelineOrgPending: emptySourceSettings,
  PipelineOrgsCount: emptySourceSettings,
};
